import axios from '@fs/zion-axios'

export default async function getPublicCollections({ cancelSource = axios.CancelToken.source() }) {
  // we need to use our own instance to prevent auto-login
  const axiosInstance = axios.create()

  return axiosInstance.get('/service/cds/recapi/collections/recordCounts?perms=CdsPrmNotSignedIn', {
    cancelToken: cancelSource.token,
  })
}
